import importMdgDialog from './create/importMdgDialogText.js';
import create from './create/text.js';

export default {
  list: {
    header: {
      notes: 'Header when listing companies',
      message: 'Companies',
    },
  },
  generalInformation: {
    header: {
      notes: 'Header for general information section',
      message: 'General information',
    },
    updateParent: {
      dialogTitle: {
        notes: 'Update parent company',
        message: 'Update parent company',
      },
      updateSuccess: {
        notes: 'Parent company was successfully updated',
        message: 'Parent company was successfully updated',
      },
      noValidParentChosen: {
        notes:
          'Errormessage if same entity as current is selected for new parent (parent to oneself is not permitted)',
        message: 'Please chose another company as parent!',
      },
    },
  },
  model: {
    name: {
      notes: 'Name field for company',
      message: 'Company name',
    },
    regionName: {
      notes: 'Name field for BLM/Region',
      message: 'Name',
    },
    companyExternalId: {
      notes: 'Label for external id (a.k.a "Company ID", "sourceId")',
      message: 'External ID',
    },
    parentRegion: {
      notes: 'Label for parent region field',
      message: 'Parent region',
    },
    parentCompany: {
      notes: 'Label for parent company (account) field',
      message: 'Parent company',
    },
    department: {
      departmentOf: {
        notes: 'Label for parent to a department',
        message: 'A department of',
      },
      chip: {
        notes: 'Chip title indicating a department',
        message: 'Department',
      },
    },
    state: {
      notes: 'T&C consent state',
      message: 'T&C consent',
      values: {
        accepted: {
          notes: 'Displaytext for state accepted',
          message: 'Accepted',
        },
        rejected: {
          notes: 'Displaytext for state rejected',
          message: 'Rejected',
        },
        pending: {
          notes: 'Displaytext for state pending',
          message: 'Pending',
        },
        pending_rejected: {
          notes: 'Displaytext for state expired (a.k.a. pending_rejected)',
          message: 'Expired',
        },
        no_admin_users: {
          notes:
            'Displaytext for state where no invites has been sent, as there are no admin user',
          message: 'Not invited',
        },
      },
    },
    agreementExpirationDate: {
      notes:
        'The date when an invite for a company will expire, i.e. the last day it is valid',
      message: 'Invite valid',
    },
  },
  capabilityBundle: {
    header: {
      notes: 'Header of capability bundle accordion for company details',
      message: 'Capabilities',
    },
  },
  action: {
    import: {
      notes: 'Title of import action',
      message: 'Import',
    },
  },
  notification: {
    importMdgCompanySuccess: {
      notes: 'Notification when successfully imported MDG company',
      message:
        '{{companyName}} imported successfully. Lets add sites, equipment and setup the first user!',
    },
  },
  importMdgDialog,
  create,
};
